
export default {
  setMasterpayerRequest(state, data) {
    state.masterpayerRequest = data
  },
  setFilter(state, filter) {
    state.masterpayerRequestFilter = filter
  },
  setMasterpayerListLoading(state, toggle) {
    state.masterpayerListLoading = toggle
  },
  clearMasterpayerRequest(state) {
    console.log('clearing')
    state.masterpayerRequest = []
  },
  clearMasterpayerRequestDetail(state) {
    state.masterpayerRequestDetail = {
      accountName: null,
      accountId: null,
      status: null,
      dedicatedMasterAccount: null, // Yes SPP, No PPA
      accountModel: null,
      sppContractType: null,
      awsSupportLevel: null,
      linkedAccountsType: null,
      contractSignatureDate: null,
      opportunityId: null,
      edpContract: null,
      controlTowerRequired: null,
      clientName: null,
      clientSfdcid: null,
      serviceLine: null,
      businessUnit: null,
      saasModel: null,
      businessJustification: null,
      controlTowerRegions: [],
      controlTowerGuardRail: null,
      controlTowerCloudTrail: null,
      requestorName: null,
      requestorEmail: null,
      requestorId: null,
    }
  },
  setMasterpayerRequestDetailLoading(state, toggle) {
    state.masterpayerRequestDetailLoading = toggle
  },
  setMasterpayerRequestDetail(state, data) {
    state.masterpayerRequestDetail = {
      ...state.masterpayerRequestDetail,
      accountName: data.Account_Name,
      accountId: data.Account_Id,
      status: data.Status,
      dedicatedMasterAccount: data.Dedicated_Master_Account, // Yes SPP, No PPA
      accountModel: data.Account_Model,
      sppContractType: data.SPP_Contract_Type,
      awsSupportLevel: data.AWS_Support_Level,
      linkedAccountsType: data.Linked_Accounts_Type,
      contractSignatureDate: data.Contract_Signature_Date,
      opportunityId: data.Opportunity_Id,
      edpContract: data.Edp_Contract,
      controlTowerRequired: data.Control_Tower_Required,
      clientName: data.Client_Name,
      clientSfdcid: data.Client_SFDC_ID,
      serviceLine: data.Service_Line,
      businessUnit: data.Business_Unit,
      saasModel: data.Saas_Model,
      businessJustification: data.Business_Justification,
      controlTowerGuardRail: data.Control_Tower_Guard_Rail,
      controlTowerCloudTrail: data.Control_Tower_Cloud_Trail,
      requestorId: data.Requestor_Id,
      controlTowerRegions: JSON.parse(data.Control_Tower_Regions),
      requestorName: `${data.Requestor_First_Name} ${data.Requestor_Last_Name}`,
      requestorEmail: data.Requestor_Email
    }
  },
  setMasterpayerStatusLoading(state, toggle) {
    state.masterpayerStatusLoading = toggle
  }
}